<template>
    <div style="margin: 10px">
        <v-form>
            <v-card>
                <div class="headline dialog-header">
                    <v-toolbar color="primary" dark>
                        <v-toolbar-title style="padding-left: 10px"
                            >{{ $t(formName) }}
                        </v-toolbar-title>
                    </v-toolbar>
                    <v-btn
                        @click="onCancel"
                        icon
                        style="
                            position: absolute;
                            right: 10px;
                            top: 10px;
                            color: #fff;
                        "
                    >
                        <v-icon>cancel</v-icon>
                    </v-btn>
                </div>
                <v-card-text>
                    <v-layout wrap>
                        <v-flex xs12 sm12 md4>
                            <div style="padding: 20px 10px">
                                <p class="font-weight-bold">
                                    Số đề nghị:
                                    {{ createItem.requestNumber }}
                                </p>
                                <p class="font-weight-bold">
                                    Người đề nghị xuất kho:
                                    {{ createItem.userCreateName }}
                                </p>
                                <div>
                                    <i-datepicker
                                        label="Ngày xuất kho yêu cầu"
                                        v-model="createItem.exportDate"
                                        @change="onChangeExportDate()"
                                    />
                                </div>
                                <div>
                                    <v-autocomplete
                                        :items="lstMaterialTypeAlly"
                                        label="Chọn nhóm của nhóm vật tư"
                                        v-model="createItem.materialTypeAllyId"
                                        item-value="categoryId"
                                        item-text="categoryName"
                                        @change="onChangeMaterialTypeAlly($event)"
                                        clearable
                                    />
                                </div>
                              <div>
                                <v-select
                                    :items="lstMaterialTypeSelect"
                                    label="Chọn nhóm vật tư"
                                    v-model="materialTypeSelected"
                                    item-value="categoryId"
                                    item-text="categoryName"
                                    @change="onChangeMatType($event)"
                                    multiple
                                />
                              </div>
                            </div>
                        </v-flex>
                        <v-flex xs12 sm12 md4>
                            <div style="padding: 20px 10px">
                                <p class="font-weight-bold">
                                    Khu nuôi: {{ areaCode }}
                                </p>
                                <p class="font-weight-bold">
                                    Vụ nuôi: {{ cropName }}
                                </p>
                                <p class="font-weight-bold">
                                    Quy trình nuôi: {{ procedureCode }}
                                </p>
                                <p class="font-weight-bold">
                                    Người nuôi: {{ famerName }}
                                </p>
                                <p class="font-weight-bold">
                                    Ngày tuổi tôm: {{ createItem.shrimpAge }}
                                </p>
                            </div>

                        </v-flex>
                        <v-flex xs12 sm12 md4>
                            <div>
                                <v-select
                                    :label="$t('Chọn G')"
                                    :items="numberGList"
                                    item-text="text"
                                    item-value="value"
                                    name="numberG"
                                    ref="numberG"
                                    v-model="createItem.numberG"
                                    disabled
                                />
                            </div>
                            <div>
                                <v-select
                                    :items="timeAm"
                                    label="Sáng"
                                    v-model="timeAmSelected"
                                    item-value="value"
                                    item-text="text"
                                    @change="onChangeTime($event, 'am')"
                                    multiple
                                />
                            </div>
                            <div>
                                <v-select
                                    :items="timePm"
                                    label="Chiều"
                                    v-model="timePmSelected"
                                    item-value="value"
                                    item-text="text"
                                    @change="onChangeTime($event, 'pm')"
                                    multiple
                                />
                            </div>
                        </v-flex>
                      <v-flex xs12 sm12 md12>
                        <v-textarea
                            outlined
                            v-validate="'max:500'"
                            label="Ghi chú"
                            rows="2"
                            v-model="createItem.content"
                            name="request_content"
                            data-vv-as="Ghi chú"
                            :error-messages="errors.first('request_content')"
                        />
                      </v-flex>
                    </v-layout>
                    <v-layout>
                        <v-flex>
                            <table class="lstTable">
                                <tr>
                                    <th rowspan="2">{{$t('lang.material.materialType')}}</th>
                                    <th rowspan="2">Tên vật tư</th>
                                    <th rowspan="2" width="80">Đơn vị</th>
                                    <th rowspan="2" width="150">Số lượng theo quy trình</th>
                                    <th rowspan="2" width="100">Tồn kho</th>
                                    <th :colspan="timeAmSelected.length == 0 ? 1 : timeAmSelected.length">Sáng</th>
                                    <th :colspan="timePmSelected.length == 0 ? 1 : timePmSelected.length">Chiều</th>
                                    <th rowspan="2">Tổng đề xuất</th>
                                </tr>
                                <tr>
                                    <th v-if="timeAmSelected.length == 0" width="60"></th>
                                    <template v-else v-for="(item, index) in timeAmSelected">
                                        <th :key="'am1'+index" width="60">{{item}}h</th>
                                    </template>

                                    <th v-if="timePmSelected.length == 0" width="60"></th>
                                    <template v-else v-for="(item, index) in timePmSelected">
                                        <th :key="'pm1'+index" width="60">{{item}}h</th>
                                    </template>
                                </tr>
                                
                                <template v-if="lstMaterial != undefined && lstMaterial != null && lstMaterial.length > 0">
                                    <template v-for="(item, index) in lstMaterial">
                                        <tr v-if="item.row === 0" :key="'mat'+index">
                                            <td style="font-weight: bold">{{item.typeName}}</td>
                                            <td colspan="7">Không có vật tư</td>
                                        </tr>
                                        <tr v-else :key="'mat'+index">
                                            <td :rowspan="item.row" v-if="item.row != undefined && parseInt(item.row) > 0" style="font-weight: bold">{{item.typeName}}</td>
                                            <td>{{ item.materialName }}</td>
                                            <td style="text-align: center">{{ item.unit }}</td>
                                            <td style="text-align: center">{{ item.total | currency }}</td>
                                            <td style="text-align: center">{{ item.inventory | currency }}</td>
                                            
                                            <template v-if="lstMaterial[index].quantityAm != undefined && lstMaterial[index].quantityAm.length > 0">
                                                <template v-for="(v2, k2) in lstMaterial[index].quantityAm">
                                                    <td v-if="lstMaterial[index].quantityAm[k2] != undefined" :key="'am' + k2">
                                                        <c-input-number
                                                            min="0"
                                                            v-model="lstMaterial[index].quantityAm[k2].value"
                                                            @keydown="keyProcess"
                                                            @change="onInputChange"
                                                            :id="'input_' + index + '_' + k2"
                                                            :data-row="index"
                                                            :data-col="k2"
                                                            data-time="am"
                                                            style="text-align: center"
                                                            :disabled="item.inventory == 0 ? true : false"
                                                        />
                                                    </td>
                                                    <td v-else :key="'am' + k2"></td>
                                                </template>
                                            </template>
                                            <td v-else></td>

                                            <template v-if="lstMaterial[index].quantityPm != undefined && lstMaterial[index].quantityPm.length > 0">
                                                <template v-for="(v3, k3) in lstMaterial[index].quantityPm">
                                                    <td v-if="lstMaterial[index].quantityPm[k3] != undefined" :key="'pm' + k3">
                                                        <c-input-number
                                                            min="0"
                                                            v-model="lstMaterial[index].quantityPm[k3].value"
                                                            @keydown="keyProcess"
                                                            @change="onInputChange"
                                                            :id="'input_' + index + '_' + (lstMaterial[index].quantityAm.length + k3)"
                                                            :data-row="index"
                                                            :data-col="lstMaterial[index].quantityAm.length + k3"
                                                            :data-col2="k3"
                                                            data-time="pm"
                                                            style="text-align: center"
                                                            :disabled="item.inventory == 0 ? true : false"
                                                        />
                                                    </td>
                                                    <td v-else :key="'pm' + k3"></td>
                                                </template>
                                            </template>
                                            <td v-else></td>

                                            <td style="text-align: center">
                                            <div v-bind:style="{ color: item.total_export >  item.total ? 'red' : ''}" >{{ item.total_export | currency }}</div>
                                            </td>

                                        </tr>
                                    </template>
                                </template>
                                <tr v-else><td colspan="100%" style="text-align: center">Không có vật tư</td></tr>
                            </table>
                        </v-flex>
                    </v-layout>
                </v-card-text>
                <v-card-actions>
                    <v-spacer />
                    <v-btn color="primary" @click="onSave" :disabled="loading">
                        {{ $t("Tạo phiếu") }}
                    </v-btn>
                    <v-btn color="error" @click="onCancel" :disabled="loading">
                        {{ $t("lang.common.back") }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-form>
    </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import IDatepicker from "../../../components/form/DatePicker";
import { message } from "../../../shared/message";
import { areaContants } from "@/constants";     
import CTextboxFloat from "@/components/form/TextboxFloat";

export default {
    name: "ExportRequestCreate",
    components: {CTextboxFloat, IDatepicker },
    data: () => {
        return {
            formName: "Tạo đề nghị xuất kho theo quy trình",
            loading: false,
            cropName: '',
            areaCode: '',
            procedureCode: '',
            famerName: '', 
            crop: '',
            timeAmSelected: [],
            timePmSelected: [],
            numberGList: areaContants.numberGList,
            lstG: [],
            timeAm: [],
            timePm: [],
            materials: [],
            lstSupplier: [],
            lstMaterialType: [],
            lstMaterialTypeAlly:[],
            lstMaterialTmp: [],
            lstMaterial: [],
            lstUser: [],
            lstProcedureData: [],
            lstMaterialTypeSelect: [],
            lstMaterialPrice: [],
            materialTypeSelected: '-1',
            requestOrder: null,
            createItem: {
                requestNumber: '',
                userCreateId: '',
                userCreateName: '',
                cropId: '',
                numberG: 1,
                exportType: 1,
                shrimpAge: '',
                warehouseId: '',
            },
        };
    },

    created() {
        // 4: kỹ sư trưởng
        const role = parseInt(this.$store.state.auth.user.role);
        if (role == 4 || role == 15) {
            this.createItem.status = 2;
        } else {
            this.createItem.status = 1;
        }
        
        this.createItem.userCreateId = this.$store.state.auth.user.userId;
        this.createItem.userCreateName = this.$store.state.auth.user.fullName;
        this.createItem.exportDate = moment().add(1, 'd').format('YYYY-MM-DD');

        this.setTimeList();
        this.getNextCode();
        this.getCrop();
        this.getMaterialType();
        this.getMaterialTypeAlly();
    },

    methods: {
        onCancel() {
            //this.$router.push({ path: '/exportRequest' });
            this.$router.push({ path: `/exportRequest`, query: this.$route.query });
            this.loading = false;
        },
        onSave() {
            if(this.lstMaterial.length < 1){
                message.error("Không có vật tư");
                return;
            }
            // const total_export = this.lstMaterial.reduce((n, {total_export}) => n + total_export, 0)
            // if (parseFloat(total_export) <= 0) {
            //     message.error("Bạn chưa nhập số lượng vật tư xuất kho");
            //     return;
            // }
            if(this.createItem.materialTypeAllyId == undefined){
              message.error("Chưa chọn nhóm của nhóm vật tư");
              return;
            }

            const lstMaterial_tmp = this.lstMaterial;
            let rt = true;

            $.each(lstMaterial_tmp, function (k, v) {
                    $.each(v.quantityAm, function (k2, v2) {
                        if (v2.value === '' && v2.inventory >0) {
                            message.error("Có vật tư chưa nhập số lượng xuất kho");
                            rt = false;
                        }
                    });
                    $.each(v.quantityPm, function (k2, v2) {
                        if (v2.value === '' && v2.inventory >0) {
                            message.error("Có vật tư chưa nhập số lượng xuất kho");
                            rt = false;
                        }
                    });

                    if (v.total_export === '' && v.inventory >0) {
                        message.error("Có vật tư chưa nhập số lượng xuất kho");
                        rt = false;
                    }
                  // console.log("total_export",  parseFloat(v.total_export));
                  // console.log("inventory",  parseFloat(v.inventory));
                  // console.log("so sanh",  parseFloat(v.total_export) > parseFloat(v.inventory));
                    if (parseFloat(v.total_export) > parseFloat(v.inventory)) {
                        message.error("Tổng đề xuất không được vượt quá số lượng tồn kho");
                        rt = false;
                    }
                    if (parseFloat(v.total_export) > parseFloat(v.total)) {
                        message.error("Tổng đề xuất không được vượt quá số lượng theo quy trình");
                        rt = false;
                    }
                    // if (parseFloat(v.total_export) < parseFloat(v.total)/2 && parseFloat(v.total_export) != 0) {
                    //     console.log(v.total_export);
                    //     console.log(parseFloat(v.total)/2);
                    //     message.error(" Tổng đề xuất không được nhỏ hơn 50% lượng theo quy trình");
                    //     rt = false;
                    // }
            });
            //test
            // console.log(lstMaterial_tmp);
            // return;
            //end test


            if(!rt){
              return;
            }
            // console.log(lstMaterial_tmp);
            const createItem = this.createItem;
            createItem.requestData = JSON.stringify(lstMaterial_tmp);
            console.log("exportRequest", createItem);
            // return;
            this.loading = true;
            axios
                .post(process.env.VUE_APP_API_URL + "/exportRequest/save", createItem)
                .then(
                    (data) => {
                        if (data.success) {
                            message.success(
                                this.$t("lang.common.save_success")
                            );
                            this.onCancel();
                        } else {
                            message.error(this.$t(data.description));
                        }

                    },
                    (error) => {
                        this.loading = false;
                        console.log(error);
                    }
                );
        },
        getCrop() {
            axios.post(
                    process.env.VUE_APP_API_URL + "/crop/search?pageSize=-1&page=-1",
                    {cropId: this.$route.params.id}
                )
                .then((data) => {
                    if (data.items) {
                        this.createItem.areaId = data.items[0].pondAreaId;
                        this.createItem.cropId = data.items[0].cropId;
                        this.createItem.procedureId = data.items[0].processId;
                        this.crop = data.items[0];
                        this.cropName = data.items[0].name;
                        
                        this.getEnvMeasure(data.items[0].processId);
                        this.getPondArea(data.items[0].pondAreaId);
                        this.getUser(data.items[0].users);
                        this.getShrimpAge();
                        //this.getProcedureDetail(data.items[0].processId);
                    }
                });
        },
        getPondArea(areaId) {
            axios.post(
                process.env.VUE_APP_API_URL + "/category/onSearchAllStatus?categoryTypeCode=PONDAREA&pageSize=-1&page=-1",
                {categoryId: areaId}
            )
            .then((data) => {
                if (data.items) {
                    this.areaCode = data.items[0].categoryName;
                    this.getWarehouse(data.items[0].categoryId);
                }
            });
        },
        getWarehouse(parentId) {
            axios.post(
                process.env.VUE_APP_API_URL + "/category/onSearchAllStatus?categoryTypeCode=WAREHOUSE&pageSize=-1&page=-1",
                {parentId: parentId}
            )
            .then((data) => {
                if (data.items) {
                    this.createItem.warehouseId = data.items[0].categoryId;
                    this.getMaterialPrice(data.items[0].categoryId);
                    this.getWarehouseInventory(data.items[0].categoryId);
                }
            });
        },
        getWarehouseInventory(warehouseId) {
            axios.post(
                    process.env.VUE_APP_API_URL + "/warehouse/search?pageSize=-1&page=-1",
                    {warehouseId: warehouseId}
                )
                .then((data) => {
                    if (data.items) {
                        this.lstInventory = data.items;
                        this.reCalculate();
                    }
                });
        },
        getProcedureDetail(procedureId) {
            axios.post(process.env.VUE_APP_API_URL + "/procedureWh/detail/" + procedureId, 
                {numberG: this.createItem.numberG}
            ).then(
                data => {
                    this.procedureCode = data.procedureWh.codeIncludeNote;
                    this.lstProcedureData = data;
                    // console.log("this.lstProcedureData",this.lstProcedureData);
                    this.reCalculate();
                    this.setMatTypeSelect();
                }
            )
        },
        getUser(stringUser) {
            const uArr = stringUser.split(",");
            axios.post(
                process.env.VUE_APP_API_URL + "/user/list", {}
            )
            .then((data) => {
                if (data.content != undefined && data.content.length > 0) {
                    const lstUser = data.content;
                    const famers = lstUser.filter(function (e) {
                        return uArr.indexOf(String(e.userId)) != -1;
                    });
                    if (famers) {
                        let listUser = ''
                        $.each(famers, function (k, v) {
                            if (k == 0) {
                                listUser += v.fullName;
                            } else {
                                listUser += ", " + v.fullName;
                            }
                        });
                        this.famerName = listUser;
                    }
                }
            });
        },
        getMaterialType() {
            axios.post(
                process.env.VUE_APP_API_URL + "/category/listByType?type=MATERIAL_TYPE"
            ).then(
                (data) => {

                    if (data.length > 0) {
                        this.lstMaterialType = data;
                    }
                }
            );
        },
        getMaterialTypeAlly() {
          axios.post(
              process.env.VUE_APP_API_URL + "/category/listByType?type=MATERIAL_TYPE_ALLY"
          ).then(
              (data) => {
                if (data.length > 0) {
                  this.lstMaterialTypeAlly = data;
                }
              }
          );
        },
        getEnvMeasure(processId) {
            axios.post(
                    process.env.VUE_APP_API_URL + "/envMeasure/search?pageSize=1&page=1",
                    {cropId: this.createItem.cropId}
                )
                .then((data) => {
                    if (data.items) {
                        this.envMeasure = data.items;
                        if (data.items[0] != undefined && data.items[0].am != undefined) {
                            let amIndex = JSON.parse(data.items[0].am);
                            if (amIndex.g != undefined) {
                                let g = amIndex.g.replace('G', '');
                                // console.log(g);
                                if (g != undefined && g != '') {
                                    this.createItem.numberG = parseInt(g);
                                  this.getProcedureDetail(processId);
                                }
                            }
                        }
                    }
                });
        },
        getNextCode() {
            axios
                .get(
                    process.env.VUE_APP_API_URL +
                        "/autoIncrease/getNextCode?type=ĐNX&prefix=ĐNX/&numberZeroBeforeCodeNumberCode=2&suffix="
                )
                .then((data) => {
                    this.createItem.requestNumber = data;
                });
        },
        keyProcess($event) {
            let group = 'input';
            let row = parseInt($event.target.getAttribute("data-row"));
            let col = parseInt($event.target.getAttribute("data-col"));
            switch ($event.keyCode) {
                case 13:
                    col += 1;
                    let id = group + '_' + row + '_' + col;
                    var element = document.getElementById(id);
                    // console.log();
                    if (typeof (element) != 'undefined' && element != null) {
                        element.focus();
                    } else {
                        row += 1;
                        col = 0;
                        id = group + '_' + row + '_' + col;
                        let element2 = document.getElementById(id);
                        if (typeof (element2) != 'undefined' && element2 != null) {
                            element2.focus();
                        } else {
                            // console.log($event.target.getAttribute("id"));
                            document.getElementById($event.target.getAttribute("id")).blur();
                        }
                    }
                    $event.preventDefault();
                    break;
                case 37:
                    // left
                    if (col >= 0) {
                        col -= 1;
                        let id = group + '_' + row + '_' + col;
                        let element = document.getElementById(id);
                        if (typeof (element) != 'undefined' && element != null) {
                            element.focus();
                        }
                    }
                    $event.preventDefault();
                    break;
                case 38:
                    // up
                    if (row >= 0) {
                        row -= 1;
                        let id = group + '_' + row + '_' + col;
                        let element = document.getElementById(id);
                        if (typeof (element) != 'undefined' && element != null) {
                            element.focus();
                        }
                    }
                    $event.preventDefault();
                    break;
                case 39:
                    //right
                    if (col >= 0) {
                        col += 1;
                        let id = group + '_' + row + '_' + col;
                        // document.getElementById(id).focus();
                        var element = document.getElementById(id);
                        if (typeof (element) != 'undefined' && element != null) {
                            element.focus();
                        }
                    }
                    $event.preventDefault();
                    break;
                case 40:
                    //down
                    if (row >= 0) {
                        row += 1;
                        let id = group + '_' + row + '_' + col;
                        var element = document.getElementById(id);
                        if (typeof (element) != 'undefined' && element != null) {
                            element.focus();
                        }
                    }
                    $event.preventDefault();
                    break;
            }
        },
        minDate() {
            const minDate = moment().format('YYYY-MM-DD');
            return minDate;
        },
        onChangeG(event) {
            // console.log(event);
        },
        onChangeTime($event, type) {
            let timeSelected = [];
            if (type == 'am') {
                this.timeAmSelected.sort((o1, o2) => {
                    return o1 - o2;
                });
                timeSelected = this.timeAmSelected;
            } else {
                this.timePmSelected.sort((o1, o2) => {
                    return o1 - o2;
                });
                timeSelected = this.timePmSelected;
            }

            for (let i = 0; i < this.lstMaterial.length; i++) {
                const quantity = [];
                let quantity_tmp = [];

                if (type == 'am') {
                    quantity_tmp = this.lstMaterial[i].quantityAm;
                } else {
                    quantity_tmp = this.lstMaterial[i].quantityPm;
                }

                $.each(timeSelected, function (k, v) {
                    const t = quantity_tmp.filter(function(o){
                        return parseFloat(v) == o.time && o.value > 0;
                    })
                    let val = '';
                    if (t != undefined && t.length > 0) {
                        val = t[0].value;
                    }

                    quantity.push({time: parseFloat(v), value: val});
                });
                quantity.sort((o1, o2) => {
                    return o1.time - o2.time;
                });

                if (type == 'am') {
                    this.lstMaterial[i].quantityAm = quantity;
                } else {
                    this.lstMaterial[i].quantityPm = quantity;
                }
                
                this.calcuTotalExport(i);
            }
        },
        getShrimpAge(calcuDate = '') {
            const item = this.crop;
            if (item == '') {
                return;
            }
            let calculateDate = calcuDate != '' ? calcuDate : moment().add('days', 1).format('YYYY-MM-DD');
            
            let shrimpAge = '';
            let dropDate = '';
            if (parseInt(item.pondParent) > 0 && item.dropDateParent != '' && item.dropDateParent != null) {
                dropDate = moment(String(item.dropDateParent));
            } else if (item.dropDate != '' && item.dropDate != null) {
                dropDate = moment(String(item.dropDate));
            }
            if (dropDate != '') {
                let calculateDateMM = moment(String(calculateDate));
                let endDate = moment(String(calculateDate));
                if (item.endDate) {
                    endDate = moment(String(item.endDate));
                    if (endDate > calculateDateMM) endDate = calculateDateMM;
                }
                if (endDate >= dropDate) {
                    let dates = endDate.diff(dropDate, "days");
                    if (dates >= 0) {
                        shrimpAge = dates;
                    }
                } else {
                    let dates = dropDate.diff(endDate, "days");
                    if (dates >= 0) {
                        shrimpAge = 0 - dates;
                    }
                }
            }
            this.createItem.shrimpAge = shrimpAge;
        },
        setTimeList() {
            for (let i = 1; i <= 12; i++) {
                this.timeAm.push({text: i + 'h', value: i});
            }
            for (let i = 13; i <= 24; i++) {
                this.timePm.push({text: i + 'h', value: i});
            }
        },
        reCalculate() {
            //
            // sum
            //
            this.lstMaterial = [];
            if (this.lstProcedureData.lstMaterial == undefined) {
                return false;
            }

            for (let i = 0; i < this.lstProcedureData.lstMaterial.length; i++) {
                this.lstMaterial.push(Object.assign({}, this.lstProcedureData.lstMaterial[i]));
            }
        //   console.log(4, this.lstMaterial);
            // console.log("5",this.lstProcedureData.lstMaterial)
            
            for (let i = 0; i < this.lstMaterial.length; i++) {
                this.lstMaterial[i].total = 0;

                for (let j = 0; j < this.lstProcedureData.lstChildrenDay.length; j++) {
                    let procedureDay = this.lstProcedureData.lstChildrenDay[j];
                    if (procedureDay.shrimpAge == this.createItem.shrimpAge) {
                        if (procedureDay.data == undefined || procedureDay.data == null || procedureDay.data == "") {
                            continue;
                        }
                        let data = JSON.parse(procedureDay.data);
                        let count = data[this.lstMaterial[i].materialId];
                        if (count != undefined && count != null && count != "") {
                            this.lstMaterial[i].total += parseFloat(count);
                        }
                    }
                }
                for (let j = 0; j < this.lstProcedureData.lstMotherDay.length; j++) {
                    let procedureDay = this.lstProcedureData.lstMotherDay[j];
                    if (procedureDay.shrimpAge == this.createItem.shrimpAge) {
                        if (procedureDay.data == undefined || procedureDay.data == null || procedureDay.data == "") {
                            continue;
                        }
                        let data = JSON.parse(procedureDay.data);
                        let count = data[this.lstMaterial[i].materialId];
                        if (count != undefined && count != null && count != "") {
                            this.lstMaterial[i].total += parseFloat(count);
                        }
                    }
                }
            }
            //
            // remove item has total = 0 and not in material type
            //
            for (let i = this.lstMaterial.length - 1; i >= 0; i--) {
                if (this.lstMaterial[i].total == 0) {
                    this.lstMaterial.splice(i, 1);
                    continue;
                }
                let bRemove = true;
                for (let j = 0; j < this.lstMaterialType.length; j++) {
                    if (this.lstMaterialType[j].categoryId == this.lstMaterial[i].typeId) {
                        bRemove = false;
                        break;
                    }
                }
                if (bRemove) {
                    this.lstMaterial.splice(i, 1);
                }
            }
            //
            // sort by typeId
            //
            this.lstMaterial.sort((o1, o2) => {
                if (o1.typeId == o2.typeId) {
                    return o1.materialName.localeCompare(o2.materialName);
                } else {
                    return o1.typeId - o2.typeId;
                }
            })

            for (let i = 0; i < this.lstMaterialType.length; i++) {
                this.lstMaterialType[i].count = 0;
                for (let j = 0; j < this.lstMaterial.length; j++) {
                    if (this.lstMaterial[j].typeId == this.lstMaterialType[i].categoryId) {
                        this.lstMaterialType[i].count++;
                    }
                }
                if (this.lstMaterialType[i].count == 0) {
                    this.lstMaterial.push({
                        typeId: this.lstMaterialType[i].categoryId,
                        typeName: this.lstMaterialType[i].categoryName,
                        row: 0
                    })
                } else {
                    for (let j = 0; j < this.lstMaterial.length; j++) {
                        if (this.lstMaterial[j].typeId == this.lstMaterialType[i].categoryId) {
                            this.lstMaterial[j].typeName = this.lstMaterialType[i].categoryName;
                            this.lstMaterial[j].row = this.lstMaterialType[i].count;
                            break;
                        }
                    }
                }

            }

            // filter total > 0

            this.lstMaterial = this.lstMaterial.filter(function (e) {
                return e.total != undefined && e.total > 0;
            });
            // filter type select
            const materialTypeSelected = this.materialTypeSelected;
            //console.log("materialTypeSelected", materialTypeSelected)
            if (this.materialTypeSelected != '-1') {
                this.lstMaterial = this.lstMaterial.filter(function (e) {
                    return materialTypeSelected.includes(e.typeId);
                });
                //console.log("lstMaterial ", this.lstMaterial);
            } else{

            }

            // inventory
            const lstInventory = this.lstInventory;
            const lstMaterial = this.lstMaterial;
            if (lstInventory != undefined && lstMaterial != undefined) {
                for (let i = lstMaterial.length - 1; i >= 0; i--) {
                    lstMaterial[i].quantityAm = [];
                    lstMaterial[i].quantityPm = [];
                    lstMaterial[i].total_export = '';
                    lstMaterial[i].inventory = 0;
                    
                    const inv = lstInventory.filter(function(o) {
                        return lstMaterial[i].materialId == o.materialId;
                    });
                    if (inv != undefined && inv[0] != undefined) {
                        lstMaterial[i].inventory = inv[0].quantity;
                    }

                    // material price
                    lstMaterial[i].price = 0;
                    const matPrice = this.lstMaterialPrice.find((v) => v.materialId === lstMaterial[i].materialId);
                    if (matPrice != undefined) {
                        lstMaterial[i].price = matPrice.averagePrice;
                    }
                }
            }
            this.lstMaterial = lstMaterial;
        },
        onInputChange($event) {
            const row = parseInt($event.target.getAttribute("data-row"));
            this.calcuTotalExport(row);
        },
        onInputChangeTextBoxFloat($event,row) {
          this.calcuTotalExport(row);
        },
        calcuTotalExport(row = 0) {
            const item = this.lstMaterial[row];
            const totalAm = item.quantityAm.reduce((n, {value}) => n + (value !='' ? parseFloat(value) : 0), 0);
            const totalPm = item.quantityPm.reduce((n, {value}) => n + (value !='' ? parseFloat(value) : 0), 0);

            const lstMaterial = this.lstMaterial;
            this.lstMaterial = [];
            //linhdx fix loi so luong vuot qua do du lieu dang 0.7000000000001
            lstMaterial[row].total_export = Number((totalAm + totalPm).toFixed(2));
            lstMaterial[row].amount = lstMaterial[row].total_export * lstMaterial[row].price;
            this.lstMaterial = lstMaterial;
        },
        onChangeExportDate() {
            this.getShrimpAge(this.createItem.exportDate);
            this.reCalculate();
            this.onChangeTime('', 'am');
            this.onChangeTime('', 'pm');
        },
        onChangeMatType() {
            this.reCalculate();
            this.onChangeTime('', 'am');
            this.onChangeTime('', 'pm');
        },
        onChangeMaterialTypeAlly() {
          //linhdx tinh lai list material
          this.lstMaterial = [];
          if (this.lstProcedureData.lstMaterial == undefined) {
            return false;
          }
          for (let i = 0; i < this.lstProcedureData.lstMaterial.length; i++) {
            this.lstMaterial.push(Object.assign({}, this.lstProcedureData.lstMaterial[i]));
          }
          this.setMatTypeSelect();
          this.reCalculate();
        },
        setMatTypeSelect() {
            let lstType = [];
            for (let i = this.lstMaterial.length - 1; i >= 0; i--) {
                lstType.push(this.lstMaterial[i].typeId)
            }
            lstType = lstType.filter((v, i, a) => a.indexOf(v) === i);

            let lstMaterialTypeSelect = this.lstMaterialType.filter(function(o) {
                return lstType.includes(o.categoryId);
            });
            this.materialTypeSelected = lstType;
            this.lstMaterialTypeSelect = lstMaterialTypeSelect;
            //linhdx neu nhom cua nhom khac null
            if(this.createItem.materialTypeAllyId != undefined){
              let a = this.createItem.materialTypeAllyId
              // loc ra danh sach cac nhom vat tu co parentId la nhom cua nhom vat tu
              let l2 = this.lstMaterialTypeSelect.filter(function (o){
                return o.parentId === a
              })
              this.lstMaterialTypeSelect = l2;
              let lstTypeSelectIdAllow = this.getAllowSelect(l2);
              // loc ra nhung vật tư đã chọn chỉ gồm các vật tư được cho phép ở trên
              this.materialTypeSelected = this.materialTypeSelected.filter(function (o){
                return lstTypeSelectIdAllow.includes(o);
              })
            }

        },
        //linhdx lay danh sach cac type duoc phep khi chon nhom cua nhom
          getAllowSelect(lstMaterialTypeSelect){
              let re = new Array();
              for(let i = 0; i < lstMaterialTypeSelect.length; i++){
                re.push(lstMaterialTypeSelect[i].categoryId);
              }
              return re;
          },
        handleInput (e) {
            let stringValue = e.target.value.toString()
            let regex = /^\d*(\.\d{1,2})?$/
            if(!stringValue.match(regex) && this.price!== '') {
                this.price = this.previousPrice
            }
            this.previousPrice = this.price
        },
        getMaterialPrice(warehouseId) {
            axios.post(
                process.env.VUE_APP_API_URL + "/materialPrice/search?pageSize=-1&page=-1", {warehouseId: warehouseId}
            )
                .then((data) => {
                    if (data.items) {
                        this.lstMaterialPrice = data.items;
                    }
                });
        },
    },

    destroyed() {},
};
</script>
